const language = {
    'pt': {
        total_departamentos: 'Total de Departamentos',
        photo: 'Carregar Foto',
        noPhoto: 'Sem Foto',
        logo: 'Carregar Logo',
        noLogo: 'Sem Logo',
        overview: 'Visão Geral',
        identification: 'Identificação',
        naturalidade: 'Naturalidade',
        associacao: 'Associação',
        segmentacao: 'Segmentação',
        settings: 'Configurações',
        dados_fiscais: 'Dados Fiscais',
        functions: 'Caracterização',
        interlocutores: 'Interlocutores',
        departamentos: 'Departamentos',

        meus_dados: 'Meus dados',
        ações: 'Ações',
        add: 'Adicionar',
        add_new: 'Adicionar Nova Entidade',
        adicionar_departamento: 'Adicionar Departamento',
        adicionar_entidade: 'Adicionar Responsáveis',
        birthday: 'Data de nascimento',
        constituicao: 'Data de constituição',
        cancel: 'Cancelar', back: 'Voltar',
        carregar: 'Carregando Informações...',
        city: 'Concelho',
        city_placeholder: 'Introduza a cidade',
        choose_profile: 'Escolha uma opção',
        close: 'Fechar',
        config: 'Configuração',
        contacto: 'Contacto',
        content: 'Conteúdo',
        content_edit: 'Editar conteúdo',
        content_list: 'Lista de conteúdos',
        content_new: 'Novo conteúdo',
        country: 'País',
        country_placeholder: 'Introduza o país',
        dark_mode: 'Dark mode',
        date_creation: 'Criação',
        date_last_update: 'Última actualização',
        date_publication: 'Publicação',
        dates: 'Datas',
        delete: 'Eliminar',
        delete_cancel: 'Não',
        delete_confirm: 'Sim',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_title: 'Eliminar Registo',
        departament: 'Dados Departamentais',
        departamento: 'Departamento',
        funcoes: 'Funções',
        dep_emp: 'Departamentos Empresariais e Certificações',
        description: 'Descrição',
        description_placeholder: 'Introduza uma descrição',
        detalhes_departamento: 'Detalhes do Departamento',
        detalhes_utilizador: 'Detalhes do Utilizador',
        detalhes_entidade: 'Detalhes da Entidade',
        district: 'Distrito',
        district_placeholder: 'Introduza o distrito',
        edit: 'Editar',
        edit_cancel: 'Não',
        edit_confirm: 'Sim',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_title: 'Editar Registo',
        email: 'E-mail',
        email_placeholder: 'Introduza o e-mail',
        entity: 'Entidade',
        entity_edit: 'Editar entidade',
        entity_externa: 'Entidades Externas',
        entity_interna: 'Entidades Internas',
        entity_list: 'Lista de entidades',
        entity_name: 'Razão Social',
        entity_new: 'Novo entidade',
        entity_type: 'Tipo de Entidade',
        entity_nature: 'Natureza jurídica',
        filter_placeholder: 'Procurar',
        id: 'ID',
        identification_number: 'Número de identificação',
        identification_number_placeholder: 'Introduza o número de identificação',
        identification_validation: 'Validade',
        image: 'Imagem',
        image_choose: 'Escolher imagem',
        insert_cancel: 'Não',
        insert_confirm: 'Sim',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_title: 'Novo Registo',
        language: 'Lingua',
        local: 'Localidade',
        local_placeholder: 'Introduza a localidade',
        login_data: 'Dados de Login',
        morada: 'Morada',
        morada_placeholder: 'Introduza a morada',
        name: 'Nome',
        name_departamento: 'Nome do departamento',
        name_placeholder: 'Introduza o nome',
        no_departamento: 'Não há departamentos disponíveis',
        nome_responsavel: 'Nome do Responsável',
        observacoes: 'Observação',
        password: 'Password',
        password_cancel: 'No',
        password_confirmation: 'Confirmação da Password',
        password_confirm: 'Continue',
        password_error: 'Problem inserting element!',
        password_placeholder: 'Introduza a password',
        password_success: 'Successful inserted element!',
        password_text: 'As Passwords não correspondem.',
        password_title: 'Password!',
        //personal_data: 'Dados Pessoais',
        personal_data: 'Dados de Entidade',
        postal_code: 'Código-postal',
        postal_code_placeholder: 'Introduza o código-postal',
        principal: 'Principal',
        profile: 'Perfil',
        razao_social: 'Razão Social',
        relacao: 'Tipo de Relação',
        remove: 'Remover',
        remove_cancel: 'Não',
        remove_confirm: 'Sim',
        remove_error: 'Problema ao remover o atributo!',
        remove_success: 'Registo removido com sucesso!',
        remove_text: 'Tem a certeza que pretende continuar?',
        remove_title: 'Remover atributo',
        responsaveis: 'Responsáveis',
        save: 'Salvar',
        save_entidade: 'Salvar Alterações',
        select: 'Selecione uma opção',
        selec_departamento: 'Selecione um departamento',
        table_actions: 'Acções',
        table_all: 'Todos',
        table_count: 'Count',
        table_date: 'Data',
        table_empty: 'Sem Resultados',
        table_parent: 'Parent',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Thumbnail',
        table_title: 'Título',
        table_type: 'Tipo',
        text: 'Texto',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        tlf: 'Telefone',
        tlf_placeholder: 'Introduza o número de telefone',
        tlm: 'Contacto',
        tlm_placeholder: 'Introduza o contacto telefonico',
        tipo: 'Tipo',
        type: 'Tipo de cliente',
        type_identification: 'Tipo de identificação',
        type_identification_placeholder: 'Introduza o tipo de identificação',
        type_placeholder: 'Introduza o tipo de cliente',
        username: 'Username',
        username_placeholder: 'Introduza o username',
        vat: 'NIF',
        vat_placeholder: 'Introduza o NIF',
        cae: 'CAE',
        cae_placeholder: 'Introduza o CAE',
        iban: 'IBAN',
        iban_placeholder: 'Introduza o IBAN',
        nbss: 'NIB',
        nbss_placeholder: 'Introduza o NIB',
        nbss: 'Nº Beneficiário da Segurança Social',
        nbss_placeholder: 'Introduza o Número de Beneficiário da Segurança Social',
        ass: 'Admissão da Segurança Social',
        ass_placeholder: 'Admissão da Segurança Social',
        village: 'Freguesia',
        village_placeholder: 'Introduza a freguesia',
        warning_cancel: 'Não',
        warning_confirm: 'Continuar',
        warning_error: 'Problema ao inserir registo!',
        warning_success: 'Registo inserido com sucesso!',
        warning_text: 'O username já existe no sistema.',
        warning_title: 'Aviso!',

        sector: 'Sector',
        dimensao: 'Dimensão',
        cliente: 'Cliente de',
        assec_sim: 'ASSEC SIM',
        assec_consultores: 'ASSEC Consultores',
        assec_ambiente: 'ASSEC Ambiente',
        group: 'Empresa do Grupo?',
        estado: 'Estado',
        ativo: 'Ativo',
        inativo: 'Inativo',
        grau_risco: 'Grau de Risco',
        fidelidade: 'Fidelização',
        sugestao: 'Aceita Sugestões',
        satisfacao: 'Grau de Satisfação',

        reduzido: 'Reduzido',
        medio: 'Médio',
        elevado: 'Elevado',
        reduzida: 'Reduzida',
        media: 'Média',
        elevada: 'Elevada',
        sim: 'Sim',
        por_vezes: 'Por vezes',
        raramente: 'Raramente',
        nunca: 'Nunca',
        insatisfeito: 'Insatisfeito',
        satisfeito: 'Satisfeito',
        muito_satisfeito: 'Muito Satisfeito',

        contribuinte: 'Número de Contribuinte',
        contribuinte_placeholder: 'Introduza o Número de Contribuinte',
        arquivo: 'Arquivo',
        arquivo_placeholder: 'Introduza o arquivo',
        validade_contribuinte: 'Validade do Contribuinte',
        validade_contribuinte_placeholder: 'Introduza a validade do contribuinte',
        identificacao: 'Identificação',
        tipo_identificacao: 'Tipo de Identificação',
        numero_identificacao: 'Número de Identificação',
        validade_identificacao: 'Validade da Identificação',

        sexo: 'Sexo',
        masculino: 'Masculino',
        feminino: 'Feminino',
        outro: 'Outro',

        estado_civil: 'Estado Civil',
        solteiro: 'Solteiro(a)',
        casado: 'Casado(a)',
        divorciado: 'Divorciado(a)',
        viuvo: 'Viúvo(a)',

        habilitacao_literaria: 'Habilitação Literária',
        ensino_basico: 'Ensino Básico',
        ensino_secundario: 'Ensino Secundário',
        licenciatura: 'Licenciatura',
        mestrado: 'Mestrado',
        doutoramento: 'Doutoramento',
        pos_doutoramento: 'Pós-Doutoramento',

        type: 'Tipo de Cliente',
        relacao: 'Relação',
        sector: 'Sector',
        dimensao: 'Dimensão',
        grau_risco: 'Grau de Risco',
        fidelidade: 'Fidelização',
        sugestao: 'Aceita Sugestões',
        satisfacao: 'Grau de Satisfação',
        phone: 'Telefone',
        mobile_phone: 'Telemóvel',
        url: 'Website',
        url_placeholder: 'Introduza o Website',

        modalidade: 'Modalidade',
        atletismo: 'Atletismo',
        voleibol: 'Voleibol',
        andebol: 'Andebol',
        futsal: 'Futsal',
        basquet: 'Basquetebol',
        futebol: 'Futebol',

        numero_interno: 'Número Interno',
        numero_interno_placeholder: 'Introduza o número interno',
        admissao: 'Data de Admissão na Federação',
        numero_atleta: 'Número de Atleta',
        numero_atleta_placeholder: 'Introduza o número de atleta',
        entrada_associacao: 'Data de Entrada na Associação',
        validade_contrato: 'Validade do Contrato',
        validade_contrato_placeholder: 'Introduza a validade do contrato',
        seguro_acidentes: 'Seguro de Acidentes Pessoais',
        seguro_acidentes_placeholder: 'Introduza o seguro de acidentes pessoais',
        data_exames_medicos: 'Data de Exames Médicos',
        data_exames_medicos_placeholder: 'Introduza a data de exames médicos',
        observacao: 'Observação',
        detalhes: 'Detalhes',
        tipo_associado: 'Tipo de Associado',
        atleta: 'Atleta',
        juvenil: 'Juvenil',
        contribuinte: 'Contribuinte',
        valor_quotas: 'Valor de Quotas',
        valor_quotas_placeholder: 'Introduza o valor de quotas',
        upload_image_error : 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n'
    },

    'en':
    {
        total_departamentos: 'Total Departments',
        segmentacao: 'Segmentation',
        cliente: 'Client of',
        photo: 'Upload Photo',
        noPhoto: 'No Photo',
        logo: 'Upload Logo',
        noLogo: 'No Logo',
        overview: 'Overview',
        settings: 'Settings',
        identification: 'Identification',
        naturalidade: 'Naturalness',
        associacao: 'Association',
        dados_fiscais: 'Fiscal Data',
        interlocutores: 'Interlocutors',
        functions: 'Characterization',
        departamentos: 'Departments',
        meus_dados: 'Personal data',
        ações: 'Actions',
        add: 'Add',
        add_new: 'Add New Entity',
        adicionar_departamento: 'Add Department',
        adicionar_entidade: 'Add Responsible Parties',
        birthday: 'Date of birth',
        constituicao: 'Date of incorporation',
        cancel: 'Cancel',
        carregar: 'Loading Information...',
        city: 'Municipality',
        city_placeholder: 'Enter the municipality',
        choose_profile: 'Choose an option',
        close: 'Close',
        config: 'Configuration',
        contacto: 'Contact',
        content: 'Content',
        content_edit: 'Edit content',
        content_list: 'Content list',
        content_new: 'New content',
        country: 'Country',
        country_placeholder: 'Enter the country',
        dark_mode: 'Dark mode',
        date_creation: 'Creation',
        date_last_update: 'Last update',
        date_publication: 'Publication',
        dates: 'Dates',
        delete: 'Delete',
        delete_cancel: 'No',
        delete_confirm: 'Yes',
        delete_error: 'Error deleting record!',
        delete_success: 'Record deleted successfully!',
        delete_text: 'Are you sure you want to proceed?',
        delete_title: 'Delete Record',
        departament: 'Departmental Data',
        departamento: 'Department',
        funcoes: 'Functions',
        dep_emp: 'Business Departments and Certifications',
        description: 'Description',
        description_placeholder: 'Enter a description',
        detalhes_departamento: 'Department Details',
        detalhes_utilizador: 'User Details',
        detalhes_entidade: 'Entity Details',
        district: 'District',
        district_placeholder: 'Enter the district',
        edit: 'Edit',
        edit_cancel: 'No',
        edit_confirm: 'Yes',
        edit_error: 'Error updating record!',
        edit_success: 'Record updated successfully!',
        edit_text: 'Are you sure you want to proceed?',
        edit_title: 'Edit Record',
        email: 'Email',
        email_placeholder: 'Enter the email',
        url: 'URL',
        url_placeholder: 'Enter the URL',
        entity: 'Entity',
        entity_edit: 'Edit entity',
        entity_externa: 'External Entities',
        entity_interna: 'Internal Entities',
        entity_list: 'Entity list',
        entity_name: 'Corporate Name',
        entity_new: 'New entity',
        entity_type: 'Entity Type',
        entity_nature: 'Natureza jurídica',
        filter_placeholder: 'Search',
        id: 'ID',
        identification_number: 'Identification number',
        identification_number_placeholder: 'Enter the identification number',
        identification_validation: 'Validation',
        image: 'Image',
        image_choose: 'Choose image',
        insert_cancel: 'No',
        insert_confirm: 'Yes',
        insert_error: 'Error inserting record!',
        insert_success: 'Record inserted successfully!',
        insert_text: 'Are you sure you want to proceed?',
        insert_title: 'New Record',
        language: 'Language',
        local: 'Locality',
        local_placeholder: 'Enter the locality',
        login_data: 'Login Data',
        morada: 'Address',
        morada_placeholder: 'Enter the address',
        name: 'Name',
        name_departamento: 'Department name',
        name_placeholder: 'Enter the name',
        no_departamento: 'No departments available',
        nome_responsavel: 'Responsible Party Name',
        observacoes: 'Observations',
        password: 'Password',
        password_cancel: 'No',
        password_confirmation: 'Password Confirmation',
        password_confirm: 'Continue',
        password_error: 'Error inserting element!',
        password_placeholder: 'Enter the password',
        password_success: 'Element inserted successfully!',
        password_text: 'Passwords do not match.',
        password_title: 'Password!',
        //personal_data: 'Personal Data',
        personal_data: 'Entity Data',
        postal_code: 'Postal code',
        postal_code_placeholder: 'Enter the postal code',
        principal: 'Principal',
        profile: 'Profile',
        razao_social: 'Corporate Name',
        relacao: 'Relationship Type',
        remove: 'Remove',
        responsaveis: 'Responsible Parties',
        save: 'Save',
        save_entidade: 'Save Changes',
        select: 'Select an option',
        selec_departamento: 'Select a department',
        table_actions: 'Actions',
        table_all: 'All',
        table_count: 'Count',
        table_date: 'Date',
        table_empty: 'No Results',
        table_parent: 'Parent',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_state: 'State',
        table_thumbnail: 'Thumbnail',
        table_title: 'Title',
        table_type: 'Type',
        text: 'Text',
        title: 'Title',
        title_placeholder: 'Enter the title',
        tlf: 'Phone',
        tlf_placeholder: 'Enter the phone number',
        tlm: 'Mobile',
        tlm_placeholder: 'Enter the mobile number',
        tipo: 'Type',
        type: 'Client type',
        type_identification: 'Identification type',
        type_identification_placeholder: 'Enter the identification type',
        type_placeholder: 'Enter the client type',
        username: 'Username',
        username_placeholder: 'Enter the username',
        vat: 'VAT',
        vat_placeholder: 'Enter the VAT',
        cae: 'CAE',
        cae_placeholder: 'Enter the CAE',
        iban: 'IBAN',
        iban_placeholder: 'Enter the IBAN',
        nbss: 'NIB',
        nbss_placeholder: 'Enter the NIB',
        ass: 'Social Security Admission',
        ass_placeholder: 'Enter the Social Security Admission',
        village: 'Parish',
        village_placeholder: 'Enter the parish',
        warning_cancel: 'No',
        warning_confirm: 'Continue',
        warning_error: 'Error inserting record!',
        warning_success: 'Record inserted successfully!',
        warning_text: 'The username already exists in the system.',
        warning_title: 'Warning!',

        sector: 'Sector',
        dimensao: 'Dimension',
        grau_risco: 'Risk Level',
        fidelidade: 'Loyalty',
        sugestao: 'Accepts Suggestions',
        satisfacao: 'Satisfaction Level',

        reduzido: 'Reduced',
        medio: 'Medium',
        elevado: 'High',
        reduzida: 'Reduced',
        media: 'Medium',
        elevada: 'High',
        sim: 'Yes',
        por_vezes: 'Sometimes',
        raramente: 'Rarely',
        nunca: 'Never',
        insatisfeito: 'Dissatisfied',
        satisfeito: 'Satisfied',
        muito_satisfeito: 'Very Satisfied',

        contribuinte: 'Tax Number',
        validade_contribuinte: 'Tax Validity',
        identificacao: 'Identification',
        tipo_identificacao: 'Identification Type',
        numero_identificacao: 'Identification Number',
        validade_identificacao: 'Identification Validity',
        sexo: 'sex',
        estado_civil: 'Marital Status',
        habilitacao_literaria: 'Literary Qualification',
        type: 'Client Type',
        relacao: 'Relationship',
        sector: 'Sector',
        dimensao: 'Dimension',
        grau_risco: 'Risk Level',
        fidelidade: 'Loyalty',
        sugestao: 'Accepts Suggestions',
        satisfacao: 'Satisfaction Level',
        observation: 'Observation',
        phone: 'Phone',
        mobile_phone: 'Mobile Phone',
        url: 'URL',
        url_placeholder: 'Enter the URL',

        group: 'Group Company?',
        modalidade: 'Modality',
        atletismo: 'Athletics',
        voleibol: 'Volleyball',
        andebol: 'Handball',
        futsal: 'Futsal',
        basquet: 'Basketball',
        futebol: 'Football',

        numero_interno: 'Internal Number',
        numero_interno_placeholder: 'Enter the internal number',
        admissao: 'Admission Date to the Federation',
        numero_atleta: 'Athlete Number',
        numero_atleta_placeholder: 'Enter the athlete number',
        entrada_associacao: 'Date of Entry into the Association',
        validade_contrato: 'Contract Validity',
        validade_contrato_placeholder: 'Enter the contract validity',
        seguro_acidentes: 'Personal Accident Insurance',
        seguro_acidentes_placeholder: 'Enter the personal accident insurance',
        data_exames_medicos: 'Medical Exams Date',
        data_exames_medicos_placeholder: 'Enter the medical exams date',
        observacao: 'Observation',
        detalhes: 'Details',
        tipo_associado: 'Member Type',
        atleta: 'Athlete',
        juvenil: 'Youth',
        contribuinte: 'Contributor',
        valor_quotas: 'Quotas Value',
        valor_quotas_placeholder: 'Enter the quotas value',

        masculino: 'male',
        feminino: 'female',
        outro: 'other',
        solteiro: 'single',
        casado: 'married',
        divorciado: 'divorced',
        viuvo: 'widowed',

        ensino_basico: 'Basic Education',
        ensino_secundario: 'Secondary Education',
        licenciatura: 'Bachelor’s Degree',
        mestrado: 'Master’s Degree',
        doutoramento: 'Doctorate',
        pos_doutoramento: 'Post-Doctorate',
        upload_image_error : 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n'
    },
    'es': {
        photo: 'Cargar Logo',
        noPhoto: 'Sin Logo',
        overview: 'Resumen',
        settings: 'Configuración',
        identification: 'Identificación',
        naturalidade: 'Naturalidad',
        associacao: 'Asociación',
        dados_fiscais: 'Datos Fiscales',

        functions: 'Funciones',
        departamentos: 'Departamentos',
        meus_dados: 'Mis datos',
        ações: 'Acciones',
        add: 'Añadir',
        add_new: 'Añadir nuevo',
        adicionar_departamento: 'Añadir Departamento',
        adicionar_entidade: 'Añadir Responsables',
        birthday: 'Fecha de nacimiento',
        cancel: 'Cancelar', back: 'Voltar',
        carregar: 'Cargando Información...',
        city: 'Municipio',
        city_placeholder: 'Introduce el municipio',
        choose_profile: 'Elige una opción',
        close: 'Cerrar',
        config: 'Configuración',
        contacto: 'Contacto',
        content: 'Contenido',
        content_edit: 'Editar contenido',
        content_list: 'Lista de contenidos',
        content_new: 'Nuevo contenido',
        country: 'País',
        country_placeholder: 'Introduce el país',
        dark_mode: 'Modo oscuro',
        date_creation: 'Creación',
        date_last_update: 'Última actualización',
        date_publication: 'Publicación',
        dates: 'Fechas',
        delete: 'Eliminar',
        delete_cancel: 'No',
        delete_confirm: 'Sí',
        delete_error: '¡Error al eliminar el registro!',
        delete_success: '¡Registro eliminado con éxito!',
        delete_text: '¿Está seguro de que desea continuar?',
        delete_title: 'Eliminar Registro',
        departament: 'Datos Departamentales',
        departamento: 'Departamento',
        dep_emp: 'Departamentos Empresariales y Certificaciones',
        description: 'Descripción',
        description_placeholder: 'Introduce una descripción',
        detalhes_departamento: 'Detalles del Departamento',
        detalhes_utilizador: 'Detalles del Usuario',
        district: 'Distrito',
        district_placeholder: 'Introduce el distrito',
        edit: 'Editar',
        edit_cancel: 'No',
        edit_confirm: 'Sí',
        edit_error: '¡Error al actualizar el registro!',
        edit_success: '¡Registro actualizado con éxito!',
        edit_text: '¿Está seguro de que desea continuar?',
        edit_title: 'Editar Registro',
        email: 'Correo electrónico',
        email_placeholder: 'Introduce el correo electrónico',
        entity: 'Entidad',
        entity_edit: 'Editar entidad',
        entity_externa: 'Entidades Externas',
        entity_interna: 'Entidades Internas',
        entity_list: 'Lista de entidades',
        entity_name: 'Razón Social',
        entity_new: 'Nueva entidad',
        entity_type: 'Tipo de Entidad',
        entity_nature: 'Natureza jurídica',
        filter_placeholder: 'Buscar',
        id: 'ID',
        identification_number: 'Número de identificación',
        identification_number_placeholder: 'Introduce el número de identificación',
        identification_validation: 'Validación',
        image: 'Imagen',
        image_choose: 'Elegir imagen',
        insert_cancel: 'No',
        insert_confirm: 'Sí',
        insert_error: '¡Error al insertar el registro!',
        insert_success: '¡Registro insertado con éxito!',
        insert_text: '¿Está seguro de que desea continuar?',
        insert_title: 'Nuevo Registro',
        language: 'Idioma',
        local: 'Localidad',
        local_placeholder: 'Introduce la localidad',
        login_data: 'Datos de Inicio de Sesión',
        morada: 'Dirección',
        morada_placeholder: 'Introduce la dirección',
        name: 'Nombre',
        name_departamento: 'Nombre del departamento',
        name_placeholder: 'Introduce el nombre',
        no_departamento: 'No hay departamentos disponibles',
        nome_responsavel: 'Nombre del Responsable',
        password: 'Contraseña',
        password_cancel: 'No',
        password_confirmation: 'Confirmación de la Contraseña',
        password_confirm: 'Continuar',
        password_error: '¡Error al insertar el elemento!',
        password_placeholder: 'Introduce la contraseña',
        password_success: '¡Elemento insertado con éxito!',
        password_text: 'Las contraseñas no coinciden.',
        password_title: '¡Contraseña!',
        personal_data: 'Datos Personales',
        postal_code: 'Código postal',
        postal_code_placeholder: 'Introduce el código postal',
        principal: 'Principal',
        profile: 'Perfil',
        razao_social: 'Razón Social',
        relacao: 'Tipo de Relación',
        remove: 'Eliminar',
        responsaveis: 'Responsables',
        save: 'Guardar',
        save_entidade: 'Guardar Cambios',
        select: 'Seleccione una opción',
        selec_departamento: 'Seleccione un departamento',
        table_actions: 'Acciones',
        table_all: 'Todos',
        table_count: 'Cantidad',
        table_date: 'Fecha',
        table_empty: 'Sin Resultados',
        table_parent: 'Padre',
        table_rows_per_page: 'Registros por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Miniatura',
        table_title: 'Título',
        table_type: 'Tipo',
        text: 'Texto',
        title: 'Título',
        title_placeholder: 'Introduce el título',
        tlf: 'Teléfono',
        tlf_placeholder: 'Introduce el número de teléfono',
        tlm: 'Móvil',
        tlm_placeholder: 'Introduce el número de móvil',
        tipo: 'Tipo',
        type: 'Tipo de cliente',
        type_identification: 'Tipo de identificación',
        type_identification_placeholder: 'Introduce el tipo de identificación',
        type_placeholder: 'Introduce el tipo de cliente',
        username: 'Nombre de usuario',
        username_placeholder: 'Introduce el nombre de usuario',
        vat: 'NIF',
        vat_placeholder: 'Introduce el NIF',
        village: 'Parroquia',
        village_placeholder: 'Introduce la parroquia',
        warning_cancel: 'No',
        warning_confirm: 'Continuar',
        warning_error: '¡Error al insertar el registro!',
        warning_success: '¡Registro insertado con éxito!',
        warning_text: 'El nombre de usuario ya existe en el sistema.',
        warning_title: '¡Advertencia!',
        sector: 'Sector',
        dimensao: 'Dimensión',
        grau_risco: 'Nivel de Riesgo',
        fidelidade: 'Fidelización',
        sugestao: 'Acepta Sugerencias',
        satisfacao: 'Nivel de Satisfacción',

        reduzido: 'Reducido',
        medio: 'Medio',
        elevado: 'Alto',
        reduzida: 'Reducida',
        media: 'Media',
        elevada: 'Alta',
        sim: 'Sí',
        por_vezes: 'A veces',
        raramente: 'Raramente',
        nunca: 'Nunca',
        insatisfeito: 'Insatisfecho',
        satisfeito: 'Satisfecho',
        muito_satisfeito: 'Muy Satisfecho',

        contribuinte: 'Número de Contribuyente',
        validade_contribuinte: 'Validez del Contribuyente',
        identificacao: 'Identificación',
        tipo_identificacao: 'Tipo de Identificación',
        numero_identificacao: 'Número de Identificación',
        validade_identificacao: 'Validez de la Identificación',

        sexo: 'Sexo',
        masculino: 'Masculino',
        feminino: 'Femenino',
        outro: 'Otro',

        estado_civil: 'Estado Civil',
        solteiro: 'Soltero(a)',
        casado: 'Casado(a)',
        divorciado: 'Divorciado(a)',
        viuvo: 'Viudo(a)',

        habilitacao_literaria: 'Habilitación Literaria',
        ensino_basico: 'Educación Básica',
        ensino_secundario: 'Educación Secundaria',
        licenciatura: 'Licenciatura',
        mestrado: 'Maestría',
        doutoramento: 'Doctorado',
        pos_doutoramento: 'Posdoctorado',

        type: 'Tipo de Cliente',
        relacao: 'Relación',
        sector: 'Sector',
        dimensao: 'Dimensión',
        grau_risco: 'Nivel de Riesgo',
        fidelidade: 'Fidelización',
        sugestao: 'Acepta Sugerencias',
        satisfacao: 'Nivel de Satisfacción',
        phone: 'Teléfono',
        mobile_phone: 'Teléfono Móvil',
        url: 'URL',
        url_placeholder: 'Introduce la URL',

        modalidade: 'Modalidad',
        atletismo: 'Atletismo',
        voleibol: 'Voleibol',
        andebol: 'Balonmano',
        futsal: 'Futsal',
        basquet: 'Baloncesto',
        futebol: 'Fútbol',

        numero_interno: 'Número Interno',
        numero_interno_placeholder: 'Introduce el número interno',
        admissao: 'Fecha de Admisión en la Federación',
        numero_atleta: 'Número de Atleta',
        numero_atleta_placeholder: 'Introduce el número de atleta',
        entrada_associacao: 'Fecha de Entrada en la Asociación',
        validade_contrato: 'Validez del Contrato',
        validade_contrato_placeholder: 'Introduce la validez del contrato',
        seguro_acidentes: 'Seguro de Accidentes Personales',
        seguro_acidentes_placeholder: 'Introduce el seguro de accidentes personales',
        data_exames_medicos: 'Fecha de Exámenes Médicos',
        data_exames_medicos_placeholder: 'Introduce la fecha de exámenes médicos',
        observacao: 'Observación',
        detalhes: 'Detalles',
        tipo_associado: 'Tipo de Asociado',
        atleta: 'Atleta',
        juvenil: 'Juvenil',
        contribuinte: 'Contribuyente',
        valor_quotas: 'Valor de Cuotas',
        valor_quotas_placeholder: 'Introduce el valor de cuotas',

        masculino: 'Masculino',
        feminino: 'Femenino',
        outro: 'Otro',
        solteiro: 'Soltero(a)',
        casado: 'Casado(a)',
        divorciado: 'Divorciado(a)',
        viuvo: 'Viudo(a)',

        ensino_basico: 'Educación Básica',
        ensino_secundario: 'Educación Secundaria',
        licenciatura: 'Licenciatura',
        mestrado: 'Maestría',
        doutoramento: 'Doctorado',
        pos_doutoramento: 'Posdoctorado',
        contribuinte: 'Número de Contribuyente',
        arquivo: 'Archivo',
        arquivo_placeholder: 'Introduce el archivo',
        validade_contribuinte: 'Validez del Contribuyente',
        validade_contribuinte_placeholder: 'Introduce la validez del contribuyente',
        identificacao: 'Identificación',
        tipo_identificacao: 'Tipo de Identificación',
        numero_identificacao: 'Número de Identificación',
        validade_identificacao: 'Validez de la Identificación',

        sexo: 'Sexo',
        masculino: 'Masculino',
        feminino: 'Femenino',
        outro: 'Otro',

        estado_civil: 'Estado Civil',
        solteiro: 'Soltero(a)',
        casado: 'Casado(a)',
        divorciado: 'Divorciado(a)',
        viuvo: 'Viudo(a)',

        habilitacao_literaria: 'Habilitación Literaria',
        ensino_basico: 'Educación Básica',
        ensino_secundario: 'Educación Secundaria',
        licenciatura: 'Licenciatura',
        mestrado: 'Maestría',
        doutoramento: 'Doctorado',
        pos_doutoramento: 'Posdoctorado',

        type: 'Tipo de Cliente',
        relacao: 'Relación',
        sector: 'Sector',
        dimensao: 'Dimensión',
        grau_risco: 'Nivel de Riesgo',
        fidelidade: 'Fidelización',
        sugestao: 'Acepta Sugerencias',
        satisfacao: 'Nivel de Satisfacción',
        phone: 'Teléfono',
        mobile_phone: 'Teléfono Móvil',
        url: 'URL',
        url_placeholder: 'Introduce la URL',
            upload_image_error : 'Apenas são permitidos ficheiros jpg, jpeg e png.\nTamanho máximo: 10MB.\n\n'
    },
}

module.exports = {
    language
};